<ng-template #filters>
    <shared-filters-draw></shared-filters-draw>
</ng-template>

<section class="main-draw"
    [ngClass]="{'-no-background': !background, '-full-height': fullHeight, '-vertical-center': verticalCenter, '-no-margin-bottom': !marginBottom}">

    <!-- <div class="main-draw__offset" directive-draw-collapse></div>

    <div class="main-draw__top">
        <ng-container *ngTemplateOutlet="null"></ng-container>
    </div> -->

    <shared-loyalty-messages *ngIf="isAppModeHomePage$ | async"></shared-loyalty-messages>

    <main class="main-draw__bd">
        <div class="main-draw__wrapper wrapper" directive-draw-min-height="adjust" [activeHeight]="activeHeight">
            <ng-container *ngTemplateOutlet="pre"></ng-container>
            <div class="main-draw__row row">
                <div class="main-draw__col col" directive-draw-content-margin [activeHeight]="activeHeight">
                    <div class="main-draw__content">
                        <ng-content></ng-content>
                    </div>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="post"></ng-container>
        </div>
    </main>

</section>